export default "__VITE_ASSET__BNp_s_TB__"